// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import jwtDecode from 'jwt-decode'

require('../src/assets/mycss.css')
require('../node_modules/bootstrap/dist/css/bootstrap.css')
require('../node_modules/bootstrap/dist/js/bootstrap.min.js')

Vue.config.productionTip = false

const PUBLIC_ROUTE_NAMES = ['Login', 'Register', 'Home']

function clearAuth () {
  localStorage.removeItem('usertoken')
  localStorage.removeItem('userType')
  localStorage.removeItem('auth')
}

function isAuthenticated () {
  const token = localStorage.getItem('usertoken')
  if (!token) return false
  try {
    const decoded = jwtDecode(token)
    if (decoded.exp < Date.now() / 1000) {
      clearAuth()
      return false
    }
    return true
  } catch (e) {
    clearAuth()
    return false
  }
}

function resolveRedirectTarget (redirect) {
  if (redirect && typeof redirect === 'string' && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return redirect
  }
  return { name: 'Home' }
}

router.beforeEach((to, from, next) => {
  if (to.name === 'Login') {
    if (isAuthenticated()) {
      next(resolveRedirectTarget(to.query.redirect))
      return
    }
    next()
    return
  }

  if (PUBLIC_ROUTE_NAMES.includes(to.name)) {
    next()
    return
  }

  if (!isAuthenticated()) {
    next({
      name: 'Login',
      query: { redirect: to.fullPath }
    })
    return
  }

  next()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js